const AUTH_TOKEN = "auth-token";
const CURRENT_EMPLOYEE = "currentEmployee";
const CURRENT_COMPANY = "currentCompany";
const CURRENT_PAYROLL_PERIOD = "currentPayrollPeriod";


const getAuthToken = () => window.localStorage.getItem(AUTH_TOKEN);
const getCurrentEmployee = () => window.localStorage.getItem(CURRENT_EMPLOYEE);
const getCurrentCompany = () => window.localStorage.getItem(CURRENT_COMPANY);
const getCurrentPayrollPeriod = () => window.localStorage.getItem(CURRENT_PAYROLL_PERIOD);

const setAuthToken = (authToken) =>
  window.localStorage.setItem(AUTH_TOKEN, authToken);
const removeAuthToken = () => {
  window.localStorage.removeItem(AUTH_TOKEN);
  window.localStorage.removeItem("currentEmployee");
  window.localStorage.removeItem("currentCompany");
};
const isAuthTokenPresent = () => getAuthToken() !== null;

const session = {
  getAuthToken,
  setAuthToken,
  removeAuthToken,
  isAuthTokenPresent,
  getCurrentEmployee,
  getCurrentCompany,
  getCurrentPayrollPeriod
};

export default session;
